export default __webpack_public_path__ + "static/media/loader.1ad7ee6d.gif";